import { useIssueActionString, type IssueActionLog } from '..'
import { format } from '@/utils/date-fns'

type Props = {
  node: IssueActionLog
}

export const ActionLogTableRowAction = (props: Props) => {
  const actionString = useIssueActionString(props.node)
  return <td>{actionString}</td>
}

const ActionLogTableRow = (props: Props) => {
  const { node } = props

  const createdAt = format(new Date(node.createdAt), 'PPpp')

  return (
    <tr key={node.id}>
      <td>{createdAt}</td>
      <ActionLogTableRowAction node={node} />
    </tr>
  )
}

export default ActionLogTableRow
